import type {ServiceResponsePayload} from '@igp/shared/api';
import type {AdjustAgentDebtInput, DebtTransferLog} from '@igp/shared/contract/pam';
import {createAsyncAction} from 'typesafe-actions';

const domain = 'debt-transfer-log';

export const debtTransferLogActions = {
    adjustAgentDebt: createAsyncAction(
        `${domain}/adjustAgentDebtRequest`,
        `${domain}/adjustAgentDebtSuccess`,
        `${domain}/adjustAgentDebtFailure`
    )<
        AdjustAgentDebtInput,
        ServiceResponsePayload<AdjustAgentDebtInput, DebtTransferLog>,
        ServiceResponsePayload<AdjustAgentDebtInput, DebtTransferLog>
    >(),
};
